const user = {
  namespaced: true,
  state: () => ({ 
    userInfo:{},//用户信息
    unitInfo:{},//单位信息
  }),
  mutations: { 
    setUserInfo(state,data){//设置用户信息
      state.userInfo=data
    },
    setUnitInfo(state,data) {//设置单位信息
      state.unitInfo=data
    },
  },
  // actions: { 
  //   login({ commit }, userInfo) {//用户登录
    
  //   },
  // },
  // getters: { 

  // }
}
export default user